module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smallView view",
    class: {
      hasIcon: _vm.icon
    },
    style: ({
      'backgroundImage': _vm.backgroundImg ? _vm.backgroundImg : '',
      'backgroundColor': _vm.backgroundImg ? '#141722' : ''
    })
  }, [_c('div', {
    staticClass: "home"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "smallView__icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/svg/icons/' + _vm.icon + '.svg',
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "smallView__country"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryHome,
      "alt": _vm.countryHome
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "smallView__title"
  }, [_c('span', {
    staticClass: "smallView__title-number",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHome.number)
    }
  }), (_vm.titleHome.hasBr) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "smallView__title-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHome.text)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "smallView__text",
    domProps: {
      "innerHTML": _vm._s(_vm.textHome)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "away"
  }, [_c('div', {
    staticClass: "smallView__country"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryAway,
      "alt": _vm.countryAway
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "smallView__title"
  }, [_c('span', {
    staticClass: "smallView__title-number",
    domProps: {
      "innerHTML": _vm._s(_vm.titleAway.number)
    }
  }), (_vm.titleAway.hasBr) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "smallView__title-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleAway.text)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "smallView__text",
    domProps: {
      "innerHTML": _vm._s(_vm.textAway)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f95be92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/smallView.vue
// module id = 648
// module chunks = 1